import LegalPolicy from "../LegalPolicy.tsx";

export default function EndUserLicenseAgreementPage() {
	return <LegalPolicy id="e50e5670-03c8-4a07-8d4a-330c82a3d981" />;
}
